import { Component, Input } from '@angular/core';


export class SkyRowComponent {
  
  public reverseColumnOrder: boolean = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-row',
  template: `<div class="sky-row" 
  [ngClass]="{ 'sky-row-reverse': reverseColumnOrder }">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-row {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
  flex-direction: row;
}

@media (min-width: 768px) {
  .sky-row.sky-row-reverse {
    flex-direction: row-reverse;
  }
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'reverseColumnOrder': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
